import React, { ChangeEvent, useState } from 'react';
import styles from './Header.module.css';
// Import Material Icons
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

interface HeaderProps {
    onLogout: () => void;
}

// Type the component with React.FC
const Header: React.FC<HeaderProps> = ({ onLogout }) => {
    // Example state with type
    const [searchTerm, setSearchTerm] = useState<string>('');

    // Type the event handler
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        // Add search logic trigger here if needed
    };

    const handleNotificationsClick = () => {
        console.log("Notifications clicked");
        // Add relevant action
    };

    const handleLogoutClick = () => {
        onLogout();
    };

    return (
        <header className={styles.header}>
            <div className={styles.searchBar}>
                <SearchIcon className={styles.icon} />
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
            </div>
            <div className={styles.headerControls}>
                <div className={styles.iconButton} onClick={handleNotificationsClick} role="button" tabIndex={0}>
                    <NotificationsIcon className={styles.icon} />
                </div>
                <div className={styles.adminInfo}>
                    <PersonIcon className={styles.icon} />
                    <span>Admin</span>
                </div>
                <div className={styles.iconButton} onClick={handleLogoutClick} role="button" tabIndex={0}>
                    <LogoutIcon className={styles.icon} />
                    <span>Logout</span>
                </div>
            </div>
        </header>
    );
};

export default Header; 